export default __webpack_public_path__ + "static/media/Watch_Front_View.d2abd6d4.png";